export default class TaskComment {
  constructor ({ _id, message, pfFileIds, created, modified, user, stateOld, stateNew }) {
    this._id = _id
    this.message = message
    this.pfFileIds = pfFileIds || []
    this.created = created
    this.modified = modified
    this.user = user
    this.stateOld = stateOld
    this.stateNew = stateNew
  }
}
